import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import {
  authenticateAction,
  fetchSession,
  getFunctionsAction,
  getGlobalVar,
} from "../redux/actions";

function ProtectedRoute(props) {
  const {
    isAuthFailed,
    isAuthenticated,
    isLogin,
    doAuthFail,
    doAuthenticate,
    getGlobalVar,
    isEmptyGlobal,
    getStaffSession,
    component: Component,
    getFunctions,
    isEmptyFunctions,
    isEmptyCount,
    ...rest
  } = props;

  const [tryAuth, settryAuth] = useState(false);
  const [loadState, setloadState] = useState({
    ready: false,
    finishLoading: false,
  });

  useEffect(() => {
    if (!isAuthenticated && !tryAuth) {
      //Check parameter
      if (isLogin) doAuthenticate();
      else getStaffSession();
      settryAuth(true);
    }
  }, [
    isAuthenticated,
    isLogin,
    tryAuth,
    settryAuth,
    doAuthenticate,
    getStaffSession,
  ]);

  useEffect(() => {
    if (isAuthenticated && isEmptyGlobal) {
      getGlobalVar();
    }
  }, [isAuthenticated, getGlobalVar, isEmptyGlobal]);

  useEffect(() => {
    if (isAuthenticated && isEmptyFunctions) {
      getFunctions();
    }
  }, [isAuthenticated, isEmptyFunctions, getFunctions]);

  //Check if auth has failed
  useEffect(() => {
    if (isAuthFailed) {
      setloadState((prevState) => {
        return { ...prevState, finishLoading: true };
      });
    }
  }, [isAuthFailed]);

  useEffect(() => {
    if (!isEmptyGlobal && !isEmptyFunctions && isAuthenticated) {
      setloadState({ finishLoading: true, ready: true });
    }
  }, [isAuthenticated, isEmptyGlobal, isEmptyFunctions]);

  return !loadState.finishLoading ? (
    <></>
  ) : (
    <Route
      {...rest}
      render={(props) =>
        loadState.ready ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/ptpsauth", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

const mapStateToProps = (state) => {
  return {
    isLogin: !_.isEmpty(state.session.staffNo),
    isAuthFailed: state.action.type === "AUTHENTICATE-ERROR",
    isAuthenticated: state.data.appointments,
    isEmptyGlobal: _.isEmpty(state.session.global),
    isEmptyFunctions: _.isEmpty(state.dashboard.functions),
    isEmptyCount: state.data.approve_req_count && state.data.endorse_req_count,
  };
};

const mapDispatchToProps = (dispatch) => ({
  doAuthenticate: () => {
    dispatch(authenticateAction());
  },
  doAuthFail: () => {
    dispatch({
      type: "AUTHENTICATE-ERROR",
      payload: { result: "EC0011", error: "user not authorized to login" },
    });
  },
  getGlobalVar: () => {
    dispatch(getGlobalVar());
  },
  getStaffSession: () => {
    dispatch(fetchSession());
  },
  getFunctions: () => {
    dispatch(getFunctionsAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
